import { CornholeRoundResponse, FortyYardDashResponse, NameFromImageResponse, PitchDataResponse } from "./models/aiVision";
import { AddImageCommand, ImageResponse, ModifyImageCommand, TextResponse } from "./models/common";
import axios from 'axios';


export async function modifyImageApi(bearerToken: string, modifyImageCommand: ModifyImageCommand): Promise<ImageResponse>{
  const baseUrl = process.env.REACT_APP_API_URL;
  const endpoint = `/api/v1/image/modify`;

  const response = await axios.post(baseUrl + endpoint, modifyImageCommand, { timeout: 90000, headers: { 'Authorization': `Bearer ${bearerToken}` } });
  return response.data as ImageResponse;
}

export async function getNameFromImageApi(bearerToken: string, modifyImageCommand: AddImageCommand): Promise<NameFromImageResponse>{
  const baseUrl = process.env.REACT_APP_API_URL;
  const endpoint = `/api/v1/image/name-from-image`;

  const response = await axios.post(baseUrl + endpoint, modifyImageCommand, { timeout: 90000, headers: { 'Authorization': `Bearer ${bearerToken}` } });
  return response.data as NameFromImageResponse;
}

export async function cornholeScoringApi(bearerToken: string, fileCommand: AddImageCommand): Promise<CornholeRoundResponse>{
  const baseUrl = process.env.REACT_APP_API_URL;
  const endpoint = `/api/v1/ai-video/cornhole-scoring`;

  const response = await axios.post(baseUrl + endpoint, fileCommand, { timeout: 90000, headers: { 'Authorization': `Bearer ${bearerToken}` } });
  return response.data as CornholeRoundResponse;
}

export async function fortyYardDashApi(bearerToken: string, videoFile: File): Promise<FortyYardDashResponse>{
  const baseUrl = process.env.REACT_APP_API_URL;
  const endpoint = `/api/v1/ai-video/forty-yard-dash-upload`;

  const formData = new FormData();
  formData.append('videoFile', videoFile); 

  const response = await axios.post(baseUrl + endpoint, formData, { timeout: 90000, headers: { 'Authorization': `Bearer ${bearerToken}` } });
  return response.data as FortyYardDashResponse;
}
  

export async function pitchSpeedApi(bearerToken: string, videoFile: File): Promise<PitchDataResponse>{
  const baseUrl = process.env.REACT_APP_API_URL;
  const endpoint = `/api/v1/ai-video/pitch-speed-analysis`;

  const formData = new FormData();
  formData.append('videoFile', videoFile);  

  const response = await axios.post(baseUrl + endpoint, formData, { timeout: 90000, headers: { 'Authorization': `Bearer ${bearerToken}` } });
  return response.data as PitchDataResponse;
}